import React from 'react';

import { useRouteMatch } from 'react-router-dom';

import image from 'assets/images/merchant-login.png';
import PageTitle from 'modules/common/components/PageTitle';
import Brand from 'modules/partial/components/Brand';

import MultiFactorAuthForm from '../forms/MultiFactorAuthForm';

function MultiFactorAuthLanding() {
  const match = useRouteMatch();

  return (
    <>
      <PageTitle title="PEP | Password Expired" />

      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="w-full min-h-screen flex relative">
          <div className="m-auto py-6 w-full">
            <div className="flex flex-col justify-center px-8 max-w-lg mx-auto">
              <Brand className="w-auto h-10 mx-auto" url={match?.url} />
              <div className="text-left mt-10 mb-6">
                <h4 className="text-xl text-primary-500 font-semibold">
                  Multi-Factor Authentication
                </h4>
                <p className="text-sm text-secondary-500 text-opacity-75 font-light">
                  As an added account security measure
                </p>
              </div>
              <MultiFactorAuthForm />
            </div>
          </div>
        </div>
        <div
          className="w-full min-h-screen bg-gray-200 hidden lg:block bg-no-repeat bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
        />
      </div>
    </>
  );
}
MultiFactorAuthLanding.defaultProps = {};

MultiFactorAuthLanding.propTypes = {};

export default MultiFactorAuthLanding;
